// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js??ref--8-2!../../../../node_modules/sass-loader/lib/loader.js??ref--8-3!./list.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("33da7770", content, true);


//////////////////
// WEBPACK FOOTER
// ./src/static/style/press/list.scss
// module id = 306
// module chunks = 4